import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../_material/material.module';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NgProgressModule } from 'ngx-progressbar';
import { NgxsModule } from '@ngxs/store';
import { UserState } from './state/user/user.state';

@NgModule({
  declarations: [],
  exports: [MaterialModule, NgProgressModule],
  imports: [
    CommonModule,
    MaterialModule,
    NgProgressModule,
    NgProgressHttpModule,
    NgxsModule.forFeature([UserState]),
  ],
  providers: [],
})
export class CoreModule {}
